/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metrics_AgentsInputs */



/**
* | output |
* | --- |
* | "agents" |
*
* @param {Metrics_AgentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metrics_agents = /** @type {((inputs?: Metrics_AgentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metrics_AgentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("agents")
});